import React, { useState, useRef, useEffect } from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import { useVariableDropdown } from './VariableDropdownContext';

export default function SlotView({
  node,
  editor,
  getPos
}: Readonly<NodeViewProps>): React.ReactElement {
  const isSystem = node.attrs.varType === 'system';
  const varName = isSystem
    ? (node.attrs.varName as string)
    : (node.attrs.slotName as string);

  const { openVariableDropdown } = useVariableDropdown();
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef<HTMLSpanElement>(null);

  const handleClick = (e: React.MouseEvent): void => {
    e.preventDefault();
    e.stopPropagation();

    if (!editor.isEditable) return;

    const pos = getPos();
    if (typeof pos !== 'number') return;

    editor.chain().focus().setNodeSelection(pos).run();

    if (openVariableDropdown && wrapperRef.current) {
      openVariableDropdown(varName, isSystem, pos, wrapperRef.current);
    } else {
      setShowDropdown(true);
    }
  };

  useEffect(() => {
    if (showDropdown) {
      const timer = setTimeout(() => setShowDropdown(false), 100);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [showDropdown]);

  return (
    <NodeViewWrapper
      as='span'
      className={`slot-chip ${editor.isEditable ? 'cursor-pointer hover:brightness-90' : ''}`}
      data-type='slotToken'
      data-vartype={node.attrs.varType}
      data-varname={varName}
      contentEditable={false}
      onClick={handleClick}
      ref={wrapperRef}
      title={editor.isEditable ? 'Click to change variable' : undefined}
    >
      {varName}
    </NodeViewWrapper>
  );
}
